import React from 'react';
import Webcam from 'react-webcam';

import Alert from '@material-ui/lab/Alert';
import { WebcamWidths } from 'constants/camera';

import WebcamError from 'components/WebcamError';

import styles from './styles.module.scss';

const WebcamDisplay = ({
  isMobile,
  selectedCameraId,
  onUserMediaError,
  webcamRef,
  containerRef,
  cameraError,
  previewImage
}) => {
  const videoConstraints = {
    // width: { ideal: 720 },
    // height: { ideal: 960 },
    aspectRatio: 3 / 4,
    deviceId: selectedCameraId ? { exact: selectedCameraId } : undefined,
    facingMode: !selectedCameraId ? 'environment' : undefined
  };

  if (cameraError) {
    return cameraError.name === 'NotReadableError' ||
      cameraError.name === 'TrackStartError' ? (
      <div className={styles.errorContainer}>
        <WebcamError />
      </div>
    ) : (
      <Alert severity="warning">
        Cannot start camera: {cameraError.toString()}
      </Alert>
    );
  }

  if (previewImage) return null;

  return (
    <div className={`${styles.cameraLayout}`} ref={containerRef}>
      <div className={styles.webcamWrapper}>
        <Webcam
          key={`${selectedCameraId}-${WebcamWidths.WEBCAM_MOBILE}`}
          className={styles.webcam}
          audio={false}
          ref={webcamRef}
          forceScreenshotSourceSize={true}
          screenshotFormat="image/jpeg"
          mirrored={!isMobile}
          screenshotQuality={1}
          videoConstraints={videoConstraints}
          onUserMediaError={onUserMediaError}
        />
        <div className={styles.webcamFrame} />
      </div>
    </div>
  );
};

export default WebcamDisplay;
